const helpers = () => {
    return {
        getResponseMessage(response) {
            let message = '';
            if (response.status === 422) {
                const errors = response.data.errors;
                const arr = [];
                for (const key in errors) {
                    if (Object.prototype.hasOwnProperty.call(errors, key)) {
                        arr.push(errors[key].join(', '))
                    }
                }
                message = arr.join('-')
            } else {
                message = response.data.message;
            }

            return message
        }
    };
};

const GlobalHelpers = {
    install(Vue) {
        Vue.prototype.$helpers = helpers()
    }
};

export default GlobalHelpers
